const CHAMPIONSHIP_HOST_ID = 'seasons-championship-host';

/** Hôte championnat encore dans le document (évite de peindre un nœud détaché après re-mount). */
export function resolveLiveChampionshipHost(fallback: HTMLElement): HTMLElement {
  if (fallback.isConnected) return fallback;
  const byId = document.getElementById(CHAMPIONSHIP_HOST_ID);
  if (byId instanceof HTMLElement) return byId;
  return fallback;
}

export function championshipHostKey(host: HTMLElement): string {
  return host.id || CHAMPIONSHIP_HOST_ID;
}
